/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SharedRespLinksBlock_item = {
    readonly popularSearchesLink: {
        readonly " $fragmentRefs": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
    };
    readonly " $refType": "SharedRespLinksBlock_item";
};
export type SharedRespLinksBlock_item$data = SharedRespLinksBlock_item;
export type SharedRespLinksBlock_item$key = {
    readonly " $data"?: SharedRespLinksBlock_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '3df590818322d1a95955cbda2b44bf7a';
export default node;
